import React from 'react'
import { SvgIcon } from '@mui/material'

export const ClearHistoryIcon = props => (
  <SvgIcon viewBox="0 0 24 24" sx={{ color: 'secondary.main' }} {...props}>
    <path
      d="M16 11h-1V3a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v8H8a5 5 0 0 0-5 5v7h18v-7a5 5 0 0 0-5-5Zm-5-8h2v8h-2V3Zm8 18h-2v-3a1 1 0 0 0-1-1 1 1 0 0 0-1 1v3h-2v-3a1 1 0 0 0-1-1 1 1 0 0 0-1 1v3H9v-3a1 1 0 0 0-1-1 1 1 0 0 0-1 1v3H5v-5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v5Z"
      fill="inherit"
    />
  </SvgIcon>
)
